var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"login-button",attrs:{"type":"primary","disabled":!_vm.initialised,"title":_vm.title},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fab fa-google"}),_vm._v("\n  Connect with Google\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fcb270d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/LoginButton.vue
// module id = null
// module chunks = 